{
  "id": 20,
  "location": "paris",
  "difficulty": "hard",
  "moves": 24,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "latte", "count": 34 }
  ],
  "stars": [3730, 4800],
  "board": [
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . X X . . .",
    ". . . X X . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.724, "movesLeft": 5.3, "closeLosses": 0.096, "target": 0.66 }
}
